import { Card, CardContent, IconButton, Stack, Tooltip } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { BinIcon, EditIcon, InfoIcon, ShapesIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'
import { YardNodeHeaderTitle } from '../atoms/YardNodeHeaderTitle'

interface Props {
  id: string
  name: string
  description?: string | null
  focused: boolean
  isEditable: boolean
  icon?: ReactNode
  onEdit: (id: string) => void
  onDelete: (id: string) => void
  deleteDisabled?: boolean
  deleteDisabledTooltip?: string
}
export const LayoutObjectHeader = observer((props: Props) => {
  const {
    name,
    description,
    focused,
    isEditable,
    icon,
    id,
    onEdit,
    onDelete,
    deleteDisabled,
    deleteDisabledTooltip,
  } = props
  const { t } = useTranslate()

  return (
    <Card>
      <CardContent sx={{ padding: '4px !important' }}>
        <Stack spacing={2} direction='row' alignItems='center' justifyContent='space-between'>
          <YardNodeHeaderTitle title={name} icon={icon ?? <ShapesIcon />} />

          {focused && (
            <>
              {description && (
                <Tooltip title={description}>
                  <InfoIcon sx={{ cursor: 'default' }} />
                </Tooltip>
              )}

              {isEditable && (
                <>
                  <Tooltip title={t('edit', 'Edit')}>
                    <IconButton onClick={() => onEdit(id)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title={
                      deleteDisabled
                        ? (deleteDisabledTooltip ?? t('delete', 'Delete'))
                        : t('delete', 'Delete')
                    }
                  >
                    <span>
                      <IconButton onClick={() => onDelete(id)} disabled={deleteDisabled}>
                        <BinIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                </>
              )}
            </>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
})
